export default "__VITE_ASSET__LjNrUvZw__"